import { ScrollObserver } from './libs/scroll';

document.addEventListener('DOMContentLoaded', function () {
  const ogSidebar = new CompanySidebar();
});

class CompanySidebar {
  constructor() {
    this.$tocItems = document.querySelectorAll('.js-sidebar-item');
    this.$contents = document.querySelectorAll('.js-content');

    this._scrollIniti();
  }

  _activeToc(num) {
    this.$tocItems.forEach((el) => {
      el.classList.remove('is-active');
    });
    this.$tocItems[num].classList.add('is-active');
  }

  _isActive(el, inview) {
    if (inview) {
      for (let i = 0; i < this.$contents.length; i++) {
        if (el == this.$contents[i]) {
          this._activeToc(i);
        }
      }
    }
  }

  _scrollIniti() {
    this.observers = new ScrollObserver(
      '.js-content',
      this._isActive.bind(this),
      {
        rootMargin: '0px 0px',
        threshold: 0.5,
        once: false,
      }
    );
  }
}
